import { createSlice } from "@reduxjs/toolkit";
import Toast from "../../base/components/Toast";
import AuthService from "../../base/services/authentication.service";
import https from "../../base/utils/http";
import { errorHandler, getErrorMessage } from "../../base/utils/errorHandler";
import { httpService } from "../../base/services/httpService.service";

const initialState = {
   isLoading: false,
   isError: false,
   errors: [],
   user: null
};

const authSlice = createSlice({
   name: "auth",
   initialState,
   reducers: {
      setLoading(state, { payload }) {
         return {
            ...state,
            isLoading: payload
         };
      },
      setIsError(state, { payload }) {
         state.isError = payload;
      },
      setErrors(state, { payload }) {
         state.errors = payload;
      },
      setAuth(state, { payload }) {
         state.trailerVideos = payload;
      },
      setUser(state, { payload }) {
         state.user = payload;
      }
   }
});

export const { setLoading, setIsError, setErrors, setAuth, setUser } = authSlice.actions;

function clearHTTPS() {
   setIsError(false);
   setErrors(null);
}

export function login(payload, successCallback, errCB) {
   clearHTTPS();
   return async (dispatch, getState) => {
      await dispatch(setLoading(true));
      httpService
         .post(
            "/account/login",
            {
               email: payload.email,
               password: payload.password
            },
            (data) => {
               dispatch(setUser(data.dataResult));

               AuthService.setUser(data.dataResult);
               AuthService.setTokens(data.dataResult.token, data.dataResult.token);

               successCallback();
            },
            (data) => {
               errCB(data);
            }
         )
         .finally(() => {
            dispatch(setLoading(false));
         });
   };
}

export function createUser(payload, successCallback) {
   clearHTTPS();
   return async (dispatch, getState) => {
      await dispatch(setLoading(true));
      https
         .post("/account/createuser", {
            email: payload.email,
            password: payload.password,
            fullName: payload.fullName
         })
         .then((response) => {
            if (response.data.success) {
               dispatch(setUser({ id: response.data.dataResult.id }));

               successCallback(response.data.dataResult);
               Toast.success("A verification code has been sent to your email.");
            }
         })
         .finally(() => {
            dispatch(setLoading(false));
         });
   };
}

export function registerUser(payload, successCallback) {
   clearHTTPS();
   return async (dispatch, getState) => {
      await dispatch(setLoading(true));
      https
         .post("/v2/Account/register/nationalOrganization", payload)
         .then((response) => {
            if (response.data.success) {
               console.log("response", response);
               dispatch(setUser({ id: response.data.dataResult.userId }));

               successCallback(response.data.dataResult);
               Toast.success("A verification code has been sent to your email.");
            }
         })
         .finally(() => {
            dispatch(setLoading(false));
         });
   };
}

export function validateConfirmationCode(code, successCallback, redirectedID) {
   return async (dispatch, getState) => {
      const id = getState()?.auth?.user?.id;

      await dispatch(setLoading(true));
      httpService
         .post(
            "/account/validateconfirmationcode",
            {
               userId: redirectedID ? redirectedID : id,
               code: code
            },
            () => {
               Toast.success("Please fill the organization information!");
               successCallback();
            }
         )
         .finally(() => {
            dispatch(setLoading(false));
         });
   };
}

export const getAuth = (state) => state.auth.auth;

export default authSlice.reducer;
